// extracted by mini-css-extract-plugin
export default {"afterSales":"index_afterSales_jHnOU","afterSalesLink":"index_afterSalesLink_LPn2Z","afterSalesPic":"index_afterSalesPic_9i35K"};